import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { authService } from '../services/api';
import { useTranslation } from 'react-i18next';

function VerifyEmailPage() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const email = searchParams.get('email') || '';

    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        if (token && email) {
            verifyEmail();
        } else {
            setStatus('error');
            setMessage(t('auth.errors.invalid_verification_link'));
        }
    }, [t]);

    const verifyEmail = async () => {
        try {
            const response = await authService.verifyEmail(email, token);
            setStatus('success');
            setMessage(response.data.message || t('auth.verify_success'));
        } catch (err) {
            setStatus('error');
            setMessage(t('auth.errors.verification_failed'));
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h1>{t('app.name')}</h1>

                {status === 'verifying' && (
                    <div style={{ textAlign: 'center', padding: '2rem' }}>
                        <p>{t('auth.verifying')}</p>
                    </div>
                )}

                {status === 'success' && (
                    <div>
                        <div className="success-message" style={{ marginBottom: '1.5rem' }}>
                            {message}
                        </div>
                        <Link to="/dashboard" className="btn-primary"
                            style={{ display: 'block', textAlign: 'center', textDecoration: 'none', padding: '0.85rem' }}>
                            {t('auth.go_dashboard')}
                        </Link>
                    </div>
                )}

                {status === 'error' && (
                    <div>
                        <div className="error-message" style={{ marginBottom: '1.5rem' }}>
                            {message}
                        </div>
                        <Link to="/dashboard" style={{ display: 'block', textAlign: 'center' }}>
                            {t('common.back_home')}
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}

export default VerifyEmailPage;